export default "__VITE_ASSET__DvxIIPk2__"